import { mainApi } from '../index';
import type { StripeConnectStatus } from './types';

/**
 * Stripe - Opens popup to /integration-authorization?connect=stripe
 */
export function getStripeAuthUrl(): string {
    return '/integration-authorization?connect=stripe';
}

/**
 * PayPal - Opens popup to /integration-authorization?connect=paypal
 */
export function getPayPalAuthUrl(returnUrl: string): string {
    return `/integration-authorization?connect=paypal&redirect=${encodeURIComponent(returnUrl)}`;
}

/**
 * Disconnect Stripe
 */
export async function disconnectStripe(): Promise<void> {
    await mainApi.delete('v1/integrations/stripe/disconnect');
}

/**
 * Disconnect PayPal - Uses integration_id
 */
export async function disconnectPayPal(integrationId: number): Promise<void> {
    await mainApi.delete(`v1/integrations/${integrationId}`);
}

/**
 * Fetch Stripe Connect Status
 * Returns detailed Stripe account status including instant payout eligibility
 */
export async function fetchStripeConnectStatus(): Promise<StripeConnectStatus> {
    const { data } = await mainApi.get<StripeConnectStatus>('v1/integrations/stripe/connect');
    return data;
}

/**
 * Update Instant Payout preference
 */
export async function updateInstantPayout(enabled: boolean): Promise<void> {
    await mainApi.post('v1/users/instant-payout-update', { instant_payout: enabled });
}
